import { render, staticRenderFns } from "./LoginProviderV2.vue?vue&type=template&id=aa071772&scoped=true&"
import script from "./LoginProviderV2.vue?vue&type=script&lang=js&"
export * from "./LoginProviderV2.vue?vue&type=script&lang=js&"
import style0 from "./LoginProviderV2.vue?vue&type=style&index=0&id=aa071772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa071772",
  null
  
)

export default component.exports